import moment from 'moment';
import { getUrlParam } from '../../services/url-params';

export interface IURLData {
    from?: string;
    to?: string;
    pickupTime?: moment.Moment;
    pickupDate?: moment.Moment;
    flightNumber?: string;
    persons?: number;
    bags?: number;
    search?: boolean;
    email?: string;
    passengerName?: string;
    reference?: string;
    drupal?: boolean;
    apiUrl?: string;
}

export default function getUrlData(): IURLData {
    const result: IURLData = {};

    // Dictionary of URL -> JS mappings
    const map: { [key in keyof IURLData]: {
        param: string,
        type: 'string' | 'number' | 'moment' | 'boolean'
    } } = {
        from: { param: 'from', type: 'string' },
        to: { param: 'to', type: 'string' },
        pickupTime: { param: 'pickup-time', type: 'moment' },
        pickupDate: { param: 'pickup-date', type: 'moment' },
        flightNumber: { param: 'flight-number', type: 'string' },
        persons: { param: 'persons', type: 'number' },
        bags: { param: 'bags', type: 'number' },
        search: { param: 'search', type: 'boolean' },
        email: { param: 'email', type: 'string' },
        passengerName: { param: 'passenger-name', type: 'string' },
        reference: { param: 'reference', type: 'string' },
        drupal: { param: 'drupal', type: 'boolean' },
        apiUrl: { param: 'api', type: 'string' }
    };

    // Read URL data
    for (const x in map) {
        if (!map.hasOwnProperty(x)) continue;
        const key = x as keyof typeof map;

        const item = map[key]!;
        let value: string | number | moment.Moment | boolean = getUrlParam(item.param);
        if (value) {
            switch (item.type) {
                case 'number':
                    value = parseInt(value, 10);
                    break;
                case 'moment':
                    value = moment(value, 'YYYY-MM-DDTHH:mm');
                    if (!value.isValid()) value = '';
                    else {
                        const minutes = value.minutes();
                        value.minutes(minutes - (minutes % 5));
                    }
                    break;
                case 'boolean':
                    value = !!value && value !== 'false';
                    break;
            }

            if (value !== '') { // @ts-ignore
                result[key] = value;
            }
        }
    }

    return result;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/url-data-reader.ts